import {
  FoundUserLookupResult,
  UserLookupResult,
} from "../../services/userLookupService";
import React, { useState } from "react";
import { locale, translation } from "../../translations";
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import Typography from "@mui/material/Typography";

export const AccountDetailsStepView = (props: {
  readonly userLookupResult: UserLookupResult;
  readonly onDeleteAccount: (
    foundUserLookupResult: FoundUserLookupResult,
  ) => void;
  readonly onGoBack: () => void;
}) => {
  const userLookupResult = props.userLookupResult;

  const [isConfirmed, setIsConfirmed] = useState(false);

  switch (userLookupResult.status) {
    case "notFound": {
      return (
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography align="center" sx={{ mb: 2 }}>
            {translation.userForProviderNotFound}
          </Typography>
          <Button onClick={props.onGoBack}>{translation.goBack}</Button>
        </Box>
      );
    }
    case "found": {
      const accountCreationTime = userLookupResult.accountCreationTime;

      return (
        <>
          {accountCreationTime !== null && (
            <Container sx={{ mb: 2 }}>
              <Typography variant="h6" align="center">
                {translation.accountCreationDate}
              </Typography>
              <Typography align="center">
                {accountCreationTime.toLocaleDateString(locale, {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </Typography>
            </Container>
          )}
          <FormGroup sx={{ mb: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isConfirmed}
                  onChange={(event) => {
                    setIsConfirmed(event.target.checked);
                  }}
                />
              }
              label={translation.deleteAccountConfirmation}
            />
          </FormGroup>
          <Button
            variant="contained"
            color="error"
            onClick={() => props.onDeleteAccount(userLookupResult)}
            disabled={!isConfirmed}
          >
            {translation.deleteAccount}
          </Button>
        </>
      );
    }
  }
};
